import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import format from 'vue-text-format';
import VCharts from 'v-charts'
import lodash from 'lodash'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import BaiduMap from 'vue-baidu-map'

Vue.use(ViewUI);
Vue.use(VueAxios, axios);
Vue.use(format);
Vue.use(VCharts);
Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999
	}
});
Vue.use(BaiduMap, {
	ak: 'LQdz8Jwap0DfF5dfGGg0OUJRFoseu9JN'
});
Vue.config.productionTip = false;
Vue.prototype._ = lodash;

let apiURL = 'https://api.wanzexinsheng.com/admin';
// let apiURL = 'http://127.0.0.1:8080/admin';
// 上传图片的URL地址
Vue.prototype.$uploadURL = `${apiURL}/image/uploadOSS`;
Vue.prototype.$apiURL = `${apiURL}`;

// 接口地址
axios.defaults.baseURL = `${apiURL}`;
axios.defaults.headers.post['Content-Type'] = 'application/json';

// 请求拦截器
// 在发送请求之前做些什么
axios.interceptors.request.use(
	(config) => {
		// 请求之前将token设置到header
		let authority = JSON.parse(sessionStorage.getItem('J-TOKEN'));
		if (authority) {
			config.headers['token'] = authority.token;
		}
		return config;
	},
	(error) => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 响应拦截器
// 对响应数据做点什么
axios.interceptors.response.use(
	(config) => {
		if (config.status == 200) {
			if (config.data.status === '401') {
				router.replace({
					path: '/login'
				}).catch(data => {});
				return false;
			}
			return config.data;
		}
		return config;
	},
	(error) => {
		// 对响应错误做点什么
		return Promise.reject(error);
	}
);


router.beforeEach((to, from, next) => {
	if (to.fullPath !== '/' && !to.name) {
		router.push('/error404');
	}
	next();
});

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
